/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WebsiteDomainStatus {
    PROVISIONAL = 'provisional',
    PENDING_DNS = 'pending_dns',
    PENDING_VALIDATION = 'pending_validation',
    ACTIVE = 'active',
    ERROR = 'error',
}
